const initAccordionWidget = () => {
    /**
     * Provides interactivity to accordion.
     * Has 2 main elements:
     * 1. Toggler: serves as on/off button
     * 2. Description: content, starts active so that js can measure its height to apply it later
     *
     */
    const accordionTogglerList = Array.from(document.querySelectorAll("[data-accordion-toggler]"));
    if (accordionTogglerList && accordionTogglerList.length > 0) {
        for (let index = 0; index < accordionTogglerList.length; index++) {
            const toggler = accordionTogglerList[index];
            const description = toggler.parentElement.querySelector("[data-height-to-toggle]");
            //get description height
            const height = parseInt(description.getBoundingClientRect().height.toString());
            //set height to data-attribute to use it on active accordion content
            description.setAttribute("data-height-to-toggle", height.toString());
            //set content height to 0
            description.style.height = "0";
            //bind a click event
            toggler.addEventListener("click", () => {
                accordionTogglerList.filter(x => x != toggler).forEach(x => {
                    //deactivate all elements but the one clicked
                    x.classList.remove("active");
                    const y = x.parentElement.querySelector("[data-height-to-toggle]");
                    y.style.height = "0";
                });
                if (!toggler.classList.contains("active")) {
                    //add class active
                    toggler.classList.toggle("active");
                    //add height to content
                    description.style.height = `${description.getAttribute("data-height-to-toggle")}px`;
                }
                else {
                    //remove class active
                    toggler.classList.remove("active");
                    //add height to content
                    description.style.height = "0";
                }
            });
        }
    }
};
